import styled from 'styled-components';

export const LabelText = styled.span`
  color: ${({ hasError }) => (hasError ? 'darkred' : 'inherit')}
  display: ${({ labelAbove }) => (labelAbove ? 'block' : 'inline-block')};
  align-self: center;
  line-height: 21px;
  text-align: ${({ labelAbove }) => (labelAbove ? 'left' : 'right')};
  width: 230px;
`;

export const ChildrenWrapper = styled.div`
  input,
  textarea,
  .SingleSelect > div,
  .MuiGrid-item > div,
  .MultiSelect > div {
    border-color: ${({ hasError }) => (hasError ? 'darkred !important' : '#ddd')}
  }
`;
